import MouseFollower from "mouse-follower";
import gsap from "gsap";

export default function initMouse() {
  MouseFollower.registerGSAP(gsap);

  const cursor = new MouseFollower({
  });
}

